// extracted by mini-css-extract-plugin
export default {"wrap":"Nr-z","fullWidth":"Or-z","items":"Pr-z","featureCss":"Qr-z","disabled":"Rr-z","imgCss":"Sr-z"};